import { UiSchema } from '@rjsf/utils';
import { JSONSchema7 } from 'json-schema';
import FileUploadWidget from 'components/form/FileUploadWidget.tsx';

function getFormSchema(showGlobalOption = false): JSONSchema7 {
  const schema: JSONSchema7 = {
    type: 'object',
    properties: {
      file: {
        type: 'object',
        title: 'Upload File',
        properties: {
          name: { type: 'string' },
          url: { type: 'string', format: 'uri' },
          size: { type: 'number' },
        },
        required: ['name'],
      },
    },
    required: ['file'],
  };

  if (showGlobalOption) {
    schema.properties!.isGlobal = {
      type: 'boolean',
      title: 'Upload as Global File',
      default: false,
    };
  }

  return schema;
}

const ACCEPTED_FILE_TYPES = [
  '.xls',
  '.xlsx',
  '.csv',
  '.docx',
  '.rtf',
  '.json',
  '.zip',
  '.tar.gz',
  '.tar.bz2',
  '.tar.xz',
  '.tar',
  '.png',
  '.jpg',
  '.jpeg',
  '.svg',
];

function getUiSchema(showGlobalOption = false, accept?: string): UiSchema {
  const uiSchema: UiSchema = {
    file: {
      'ui:field': FileUploadWidget,
      'ui:options': {
        accept: accept ?? ACCEPTED_FILE_TYPES.join(','),
      },
    },
  };

  if (showGlobalOption) {
    uiSchema.isGlobal = {
      'ui:widget': 'checkbox',
      'ui:options': {
        label: 'Upload as Global File (accessible across all projects)',
      },
    };
  }

  return uiSchema;
}

export { getFormSchema, getUiSchema };
